import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { clearItemCategories, getItemCategories } from '../../../actions';
import { DEFAULT_QUERY_GET_ALL } from '../../../config/queries';
import SelectFilter from './SelectFilter';
import { optionPropTypes } from '../forms/select/SelectPropTypes';

const ItemCategoryFilter = ({
  dispatchGetItemCategories,
  dispatchClearItemCategories,
  options,
  loading,
  isMulti,
  isClearable,
  ...rest
}) => {

  useLayoutEffect(() => {
    dispatchGetItemCategories(DEFAULT_QUERY_GET_ALL, null);
    return () => {
      dispatchClearItemCategories(null);
    };
  }, []);

  return (
    <SelectFilter
      isLoading={loading}
      options={options}
      isMulti={isMulti}
      isClearable={isClearable}
      {...rest}
    />
  );
};

ItemCategoryFilter.propTypes = {
  dispatchGetItemCategories: PropTypes.func.isRequired,
  dispatchClearItemCategories: PropTypes.func.isRequired,
  options: optionPropTypes.isRequired,
  loading: PropTypes.bool,
  isMulti: PropTypes.bool,
  isClearable: PropTypes.bool,
  placeholder: PropTypes.string,
};

ItemCategoryFilter.defaultProps = {
  placeholder: 'Seleccione categoría',
  isMulti: false,
  loading: false,
  isClearable: true,
};

const mapStateToProps = ({ BaggageUnit }) => ({
  options: BaggageUnit.ItemCategory.getIn(['all', 'content', 'content']).map(
    ({ id, name }) => ({
      value: id,
      label: name,
    }),
  ),
  loading: BaggageUnit.ItemCategory.getIn(['all', 'loading']),
});

const mapDispatchToProps = {
  dispatchGetItemCategories: getItemCategories,
  dispatchClearItemCategories: clearItemCategories,
};

export default connect(mapStateToProps, mapDispatchToProps)(ItemCategoryFilter);
